import { render } from "./ProspectPageViews.vue?vue&type=template&id=5367ae3b"
import script from "./ProspectPageViews.vue?vue&type=script&lang=js"
export * from "./ProspectPageViews.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__